import 'lowcode/common/css/global.scss';
import * as CodeTemp from 'lowcode/plugins/indexS';
import * as CodeTemp2 from 'lowcode/plugins2/indexS';
import Empty from 'lowcode/utils/Empty';
import 'lowcomp/plugins/blog/blog.scss';
import Head from 'next/head';
import { Fragment } from 'react';

import * as LowcompBlog from 'lowcomp/plugins/blog/indexS';
import * as LowcompIndex from 'lowcomp/plugins/index-series/indexS';

const defaultTemp = {
    ...LowcompIndex,
    ...LowcompBlog,
    ...CodeTemp2,
    ...CodeTemp, //常用的务必在后面
};

export default function ProductBlog({ allTemp = {}, data = {}, className }: any) {
    const { thePage = {}, theTemp = [], theData = {}, theAttr = {}, sqlData = {} } = data;
    const theme = thePage.theme || 'white'; //主题色
    const className2 = className ? ` ${className}` : '';
    // 是否开启header设置
    const isOpenNoFollow = thePage.isNoFollow === 'true'; //必须要是字符串|不开启SEO抓取
    const isOpenHeadC = isOpenNoFollow;

    return (
        <div className={`editor-product ${`editor-${theme}`}${className2}`}>
            {theTemp?.map((item: any) => {
                const id = item.id;
                const name = item.name;
                const ContentA = (defaultTemp as any)[name] || allTemp[name] || Empty;
                // 设置一层隐藏功能
                if (item.__hide) {
                    return null;
                }
                return (
                    <Fragment key={id}>
                        <ContentA
                            lowCodeType="preview"
                            id={id}
                            data={theData[id] || {}}
                            attr={theAttr[id] || {}}
                            theme={theme}
                            thePage={thePage}
                            tempData={data}
                        />
                    </Fragment>
                );
            })}
            {isOpenHeadC && (
                <Fragment>
                    <Head>
                        {isOpenNoFollow && (
                            <>
                                <meta name="robots" content="noindex, nofollow" key="robots" />
                                <meta name="googlebot" content="noindex, nofollow" key="googlebot" />
                            </>
                        )}
                    </Head>
                </Fragment>
            )}
        </div>
    );
}
